// extracted by mini-css-extract-plugin
export default {"infoCard":"InstrumentInfo_infoCard__aBbM4","icon":"InstrumentInfo_icon__5Iz3S"};